<template lang="pug">
BlogView(v-if="isBlog")
PageView(v-else)
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import blogSlugs from '@/content/blog-slugs.json';

definePageMeta({
  layout: 'minimal',
});

const route = useRoute();

const isBlog = computed(() => blogSlugs?.includes(route.path));
</script>